module.exports = __webpack_public_path__ + "assets/images/img/01.7cc11b64e51c37787abeecded709cfcc.jpg";